import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AudioPlayerService {
    private player$ = new BehaviorSubject<string>(null);
    selectedPlayer$ = this.player$.asObservable();

    constructor() { }

    setPlayer(player:any){
        this.player$.next(player);
    }

}
